import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EntrenadoresComponent } from './entrenadores/entrenadores.component';
import { TrainerDashboardComponent } from './trainer-dashboard.component';
import { ConstructorRutinasComponent } from './constructor-rutinas/constructor-rutinas.component';
import { ConstructorGuiasComponent } from './constructor-guias/constructor-guias.component';
import { ConstructorDietasComponent } from './constructor-dietas/constructor-dietas.component';
import { MiPerfilComponent } from 'src/app/components/mi-perfil/mi-perfil.component';
import {ProgramasComponent} from "./programas/programas.component";
import {PlantillasComponent} from "./plantillas/plantillas.component";
import {ClientesComponent} from "./clientes/clientes.component";
import { ConfigAvanzadaComponent } from './programas/config-avanzada/config-avanzada.component';

const routes: Routes = [
  { path: '', component: TrainerDashboardComponent },
  { path: 'entrenadores', component: EntrenadoresComponent },
  { path: 'rutinas', component: ConstructorRutinasComponent },
  { path: 'rutinas/:clienteId/:programaId/:periodoId', component: ConstructorRutinasComponent },
  { path: 'rutinas/:programaId/:periodoId', component: ConstructorRutinasComponent },
  { path: 'guias', component: ConstructorGuiasComponent },
  { path: 'guias/:clienteId/:programaId', component: ConstructorGuiasComponent },
  { path: 'guias/:programaId', component: ConstructorGuiasComponent },
  { path: 'dietas', component: ConstructorDietasComponent },
  { path: 'dietas/:clienteId/:programaId/:periodoId', component: ConstructorDietasComponent },
  { path: 'dietas/:programaId/:periodoId', component: ConstructorDietasComponent },
  { path: 'mi-cuenta', component: MiPerfilComponent},
  { path: 'programas', component: ProgramasComponent},
  { path: 'plantillas', component: PlantillasComponent},
  { path: 'clientes', component: ClientesComponent},
  { path: 'config-programa/:id', component: ConfigAvanzadaComponent},

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EntrenadoresRoutingModule { }
